import { Button } from '../../cdl/Button/Button';
import { useDrawer } from '../../cdl/Drawer/useDrawer.hook';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { useDocumentTitle } from '../../common/hooks/useDocumentTitle';
import { IconPlus } from '../../common/icons/cdl/Plus';
import { Page } from '../../common/Page/Page';
import { PageGrid } from '../../common/PageGrid';
import { Box } from '../../common/ui/Box';

import { CreateSupplierGroup } from './components/CreateSupplierGroup';
import { SupplierGroupsFilterPills } from './components/SupplierGroupsFilterPills';
import { SupplierGroupsTable } from './components/SupplierGroupsTable';

export const SupplierGroupsOverviewPage = () => {
    useDocumentTitle(translate('page.suppliergroupoverview'));

    const { push, pop } = useDrawer();

    return (
        <Page>
            <PageGrid>
                <Box display="flex" justifyContent="space-between" alignItems="center" gap={16}>
                    <Text variant="headline" as="h1">
                        {translate('suppliergroups.headline')}
                    </Text>

                    <Button
                        emphasis="high"
                        LeadingIcon={IconPlus}
                        onClick={() => {
                            const drawerId = push({
                                header: { title: translate('suppliergroups.create') },
                                content: <CreateSupplierGroup onSuccess={() => pop(drawerId)} />,
                            });
                        }}
                    >
                        {translate('suppliergroups.create')}
                    </Button>
                </Box>

                <SupplierGroupsFilterPills />

                <SupplierGroupsTable />
            </PageGrid>
        </Page>
    );
};
